import flatten from 'lodash.flatten';
import isObject from './is-object';

// TODO this helper should be removed if database is wiped clean and all elements change to new props struc
const checkPropsToUse = (propsToDisplay = []) =>
  propsToDisplay && isObject(propsToDisplay[0])
    ? flatten(propsToDisplay.map(({ propertiesToDisplay }) => propertiesToDisplay))
    : propsToDisplay;

export default checkPropsToUse;
